/**
 * ExpansionUpsellIcon — Mi6 custom glyph: branching growth tree / arrow
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function ExpansionUpsellIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Trunk */}
      <line x1="40" y1="68" x2="40" y2="44" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Main trunk up */}
      <line x1="40" y1="44" x2="40" y2="24" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Root branches */}
      <line x1="40" y1="60" x2="28" y2="68" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="40" y1="60" x2="52" y2="68" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Mid branches */}
      <line x1="40" y1="44" x2="26" y2="52" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="40" y1="44" x2="54" y2="52" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Upper branches */}
      <line x1="40" y1="32" x2="28" y2="24" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="40" y1="32" x2="52" y2="24" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* Top arrow / apex growth */}
      <line x1="40" y1="24" x2="40" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="35,18 40,12 45,18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Branch tip dots */}
      <circle cx="26" cy="52" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="54" cy="52" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="28" cy="24" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="52" cy="24" r="2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
